var _g, _g2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIFileXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2435_61344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48715 36.8457V7.28125H6.20312V40.1297H30.9201V36.8457H9.48715Z",
    fill: "#F4F6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2435_61344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48438 4V36.8485H34.2014V11.5193L26.6821 4H9.48438Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.199 11.5193L26.6797 4V11.5193H34.199Z",
    fill: "#F4F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3756 20.5469H18.4049L19.3084 19.0391H20.3352L18.9975 21.2275L20.3645 23.4159H19.3143L18.4049 21.908H18.3756L17.4662 23.4159H16.4219L17.7948 21.2275L16.4453 19.0391H17.4779L18.3756 20.5469Z",
    fill: "#82868C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8867 19.0391H21.7961V22.6707H23.6853V23.4217H20.8926V19.0391H20.8867Z",
    fill: "#82868C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4171 19.8977C26.2821 19.7979 26.1061 19.751 25.889 19.751C25.7365 19.751 25.6074 19.7744 25.5018 19.8155C25.3962 19.8566 25.3141 19.9211 25.2554 19.9974C25.1967 20.0737 25.1732 20.1617 25.1732 20.2614C25.1732 20.4022 25.2378 20.5137 25.361 20.6017C25.4901 20.6838 25.6602 20.7542 25.8714 20.8012L26.2645 20.9009C26.6693 20.9889 26.992 21.1415 27.2267 21.3527C27.4614 21.5639 27.5787 21.8396 27.5787 22.1858C27.5787 22.4557 27.5083 22.6845 27.3734 22.884C27.2384 23.0776 27.0448 23.2301 26.7867 23.3416C26.5285 23.4531 26.2293 23.5 25.8773 23.5C25.5253 23.5 25.2143 23.4472 24.9562 23.3357C24.698 23.2243 24.4927 23.0658 24.346 22.8546C24.1993 22.6434 24.1231 22.3794 24.1172 22.0743H25.0031C25.0148 22.2914 25.1028 22.4557 25.2613 22.5671C25.4197 22.6786 25.6191 22.7373 25.8714 22.7373C26.0298 22.7373 26.1648 22.7138 26.288 22.6669C26.4112 22.6199 26.4992 22.5554 26.5637 22.4733C26.6283 22.3911 26.6635 22.2973 26.6635 22.1858C26.6635 22.045 26.6048 21.9335 26.4816 21.8514C26.3584 21.7692 26.1706 21.693 25.9125 21.6284L25.4373 21.5111C24.6452 21.3175 24.2463 20.9185 24.2463 20.3201C24.2463 20.0561 24.3167 19.8272 24.4575 19.6278C24.5983 19.4283 24.7978 19.2699 25.05 19.1643C25.3023 19.0528 25.5839 19 25.9008 19C26.2176 19 26.4992 19.0528 26.7456 19.1643C26.992 19.2757 27.1798 19.4283 27.3147 19.6278C27.4497 19.8272 27.5201 20.0561 27.5259 20.3083H26.6576C26.64 20.1323 26.5637 19.9974 26.4288 19.9035L26.4171 19.8977Z",
    fill: "#82868C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2435_61344",
    x: 2.20312,
    y: 3.28125,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2435_61344",
    x: 5.48438,
    y: 0,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61344",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFileXls);
export default __webpack_public_path__ + "static/media/i_file_xls.94d03633228b2a82cd7ea343ae128007.svg";
export { ForwardRef as ReactComponent };